import { Close, Delete, Done, Edit } from "@mui/icons-material";

export const ACTION_TYPE = {
  reject: "reject",
  approve: "approve",
  edit: "edit",
  delete: "delete",
};

// Possible actions user can perform on an invoice
export const actions = [
  {
    icon: <Close />,
    label: "Reject",
    id: ACTION_TYPE.reject,
  },
  {
    icon: <Done />,
    label: "Approve",
    id: ACTION_TYPE.approve,
    primary: true,
  },
  {
    icon: <Edit />,
    id: ACTION_TYPE.edit,
  },
  {
    icon: <Delete />,
    id: ACTION_TYPE.delete,
  },
];
